import { useTranslation } from 'react-i18next';
import { RouteTabs } from '../shared/RouteTabs';

// The two views of a federation's performance: the whole cohort, and the officials in it.
//
// `end` on the overview matters — /admin/analytics is a prefix of /admin/analytics/referees, so
// without it both tabs light up while the roster is open.
export function AnalyticsTabs() {
  const { t } = useTranslation();
  return (
    <RouteTabs
      tabs={[
        { to: '/admin/analytics', label: t('admin.analytics.tabs.federation'), end: true },
        { to: '/admin/analytics/referees', label: t('admin.analytics.tabs.referees') },
      ]}
    />
  );
}
